import {
  loginFailure,
  loginStart,
  loginSuccess,
  loginLocked,
  sessionSuccess,
  logoutStart,
} from "../reducers/loginRedux";
import { publicRequest } from "../../requestMeth";
import { logoutInfoCompanies } from "../reducers/master/companiesRedux";
import { logoutInfousers } from "../reducers/master/allusersRedux";
import { logoutInfoDevices } from "../reducers/admin/devicesRedux";
import { logoutpassPolicies } from "../reducers/master/passPoliciesRedux";
import { logoutCompany } from "../reducers/master/editCompanyRedux";
import { logoutInfoEquipos } from "../reducers/master/equiposRedux";
import { logoutInfoparametros } from "../reducers/master/parametrosRedux";
import { logoutInfoData } from "../reducers/admin/ebmDataRedux";
import { logoutInfoItemsBill } from "../reducers/admin/itemBills";
import { logoutEditItemBill } from "../reducers/admin/editItemBills";
import { logoutInfosuppliers } from "../reducers/master/suppliersRedux";
import { logoutInfoSupplier } from "../reducers/master/suppliersOfficeRedux";
import { logoutEnergyMeters } from "../reducers/admin/energyMetersRedux";
import { logoutSuggestions } from "../reducers/suggestions/suggestionsRedux";
import { logoutMesagges } from "../reducers/mesagges/mesaggesRedux";
import { logoutUploadBill } from "../reducers/admin/uploadBillReducer";
import { logoutInfoparametros_calculados } from "../reducers/admin/calculatedParametersRedux";
import { logoutInfoparametros_basico } from "../reducers/admin/basicParametersRedux";
import { logoutInfoDevice } from "../reducers/admin/editDeviceRedux";
import { logoutInfoMaximetro } from "../reducers/data/maximetroRedux";
import { logoutInfologgers } from "../reducers/master/loggersReducer";
import { logoutHealthSafetyReport } from "../reducers/healthSafetyRedux";
import { logoutUserEdit } from "../reducers/admin/editUserRedux";
import { logoutInfoAlerts } from "../reducers/alertsRedux";
import { logoutInfoAlertEvents } from "../reducers/alertEventsRedux";
import { logoutEquiposEdit } from "../reducers/master/editEquipoRedux";
import { logoutMeasurementGroupsData } from "../reducers/data/dataRedux";
import { logoutLoadDemanded } from "../reducers/analysis/loadDemandedRedux";
import { logoutInvoicePenaltyUserNotifications } from "../reducers/invoicePenaltyUserNotificationsReducer";
import { logoutInfoNews } from "../reducers/newsRedux";
import { clearAllConsultantStorage } from "../../features/consultant/consultantPersistence";

export const login = async (dispatch, user) => {
  dispatch(loginStart());
  try {
    const res = await publicRequest.post("/auth/users/login", user);
    dispatch(loginSuccess(res.data));
  } catch (error) {
    console.log("ERROR", error);
    if (error.response?.status === 423) {
      dispatch(loginLocked());
    } else {
      dispatch(loginFailure());
    }
  }
};

export const session = async (dispatch, user, token) => {
  try {
    const res = await publicRequest.get("/auth/users/session", {
      headers: { token: `Bearer ${token}` },
    });
    const local = localStorage.getItem("persist:root");
    let localPars = JSON.parse(local);
    let a = JSON.parse(localPars.user);
    if (res.data.newToken) {
      a.currentUser = { ...a.currentUser, accessToken: res.data.newToken };
      localPars.user = JSON.stringify(a);
      localStorage.setItem("persist:root", JSON.stringify(localPars));
      dispatch(sessionSuccess(res.data));
    }
  } catch (error) {
    console.log(error);
  }
};

export const logoutUser = (dispatch) => {
  clearAllConsultantStorage();
  localStorage.removeItem("persist:root");
  localStorage.removeItem("selectedDevices");
  localStorage.removeItem("dataEbm");
  localStorage.removeItem("data");
  localStorage.removeItem("itemsBill");
  localStorage.removeItem("editItemBill");
  localStorage.removeItem("selectedGroups");
  localStorage.removeItem("selectedCompany");
  localStorage.removeItem("selectedMeasureType");
  localStorage.removeItem("supplier");
  localStorage.removeItem("supplierOffice");
  localStorage.removeItem("eMetersCreate");
  localStorage.removeItem("suggestions");
  localStorage.removeItem("uploadBill");
  localStorage.removeItem("calculatedParameter");
  localStorage.removeItem("SelectDates");
  localStorage.removeItem("loggers");
  localStorage.removeItem("healthSafety");
  localStorage.removeItem("logoutUserEdit");
  localStorage.removeItem("alerts_events");
  localStorage.removeItem("hs_category_tree_v1");
  localStorage.removeItem("measurement_firstSelect");
  localStorage.removeItem("consumption_state");
  localStorage.removeItem("evolution_state");
  localStorage.removeItem("comfort_state");
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("dashboard_filters_prev_")) {
      localStorage.removeItem(key);
    }
  });
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("sigerbot_session_")) {
      localStorage.removeItem(key);
    }
  });
  Object.keys(localStorage).forEach((key) => {
  if (key.includes("downloadData")) {
    localStorage.removeItem(key);
  }
});

localStorage.removeItem("activeReportIdReports");
localStorage.removeItem("loadDemanded");


  dispatch(logoutStart());
  dispatch(logoutUploadBill());
  dispatch(logoutInfousers());
  dispatch(logoutInfoCompanies());
  dispatch(logoutInfoDevices());
  dispatch(logoutpassPolicies());
  dispatch(logoutCompany());
  dispatch(logoutInfoEquipos());
  dispatch(logoutInfoparametros());
  dispatch(logoutInfoData());
  dispatch(logoutInfoMaximetro());
  dispatch(logoutInfoItemsBill());
  dispatch(logoutEditItemBill());
  dispatch(logoutInfosuppliers());
  dispatch(logoutInfoSupplier());
  dispatch(logoutEnergyMeters());
  dispatch(logoutInfoparametros_calculados());
  dispatch(logoutInfoparametros_basico());
  dispatch(logoutSuggestions());
  dispatch(logoutMesagges());
  dispatch(logoutInfoDevice());
  dispatch(logoutInfologgers());
  dispatch(logoutHealthSafetyReport());
  dispatch(logoutUserEdit());
  dispatch(logoutInfoAlerts());
  dispatch(logoutInfoAlertEvents());
  dispatch(logoutEquiposEdit());
  dispatch(logoutMeasurementGroupsData());
  dispatch(logoutLoadDemanded())
  dispatch(logoutInvoicePenaltyUserNotifications());
  dispatch(logoutInfoNews());
};
